import axios from 'axios'
import store from '../store'

export default {
  methods: {
    async getLocationLedgernumbers(locationId) {
      const response = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/ledgernumber/location/${locationId}`,
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken']
          }
        }
      )
      return response
    },

    async saveLocationLedgerNumbers(locationId, ledgernumbers) {
      let criteria = {
        LedgerNumbers: ledgernumbers
      }

      const response = await axios.post(
        `${process.env.VUE_APP_API_BASE_URL}/api/v1/ledgernumber/location/${locationId}`,
        JSON.stringify(criteria),
        {
          headers: {
            'Content-type': 'application/json',
            apiToken: process.env.VUE_APP_API_KEY,
            profileToken: store.getters['profileStore/getProfileToken']
          }
        }
      )
      return response
    }
  }
}
